export default __webpack_public_path__ + "static/media/event-menu-file-text.1b70d1ed.svg";